import {EnhancementProductStat} from '../../../models/enhancement/enhancement-report-stats'
import Top20Table from './Top20Table'
import {Top20ProductsTableData} from './utils'
import { TableEmptyState } from "../TableEmptyState"

interface Top20ProductsTableProps {
  data: EnhancementProductStat[],
  selectedRequestTypes?: string[] | null
}

function Top20ProductsTable({ data, selectedRequestTypes }: Readonly<Top20ProductsTableProps>) {
  // Only show data if no filter is selected or if "Call Out" is selected
  const shouldShowData = !selectedRequestTypes || selectedRequestTypes.length === 0 || selectedRequestTypes.includes('Call Out')
  
  // If filters are applied but "Call Out" is not selected, show specific message
  if (selectedRequestTypes && selectedRequestTypes.length > 0 && !selectedRequestTypes.includes('Call Out')) {
    return <TableEmptyState message="No data available - 'Call Out' not selected in filters" />
  }
  
  const filteredData = shouldShowData ? data : []
  const tableData = Top20ProductsTableData(filteredData)

  return (
    <Top20Table data={tableData} />
  )
}

export default Top20ProductsTable
